var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFullscreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fullscreen_svg__dr",
    xmlns: "http://www.w3.org/2000/svg",
    width: 430,
    height: 430,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 430 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fullscreen_svg__ds",
    x1: 250.24,
    y1: 123.72,
    x2: 362.68,
    y2: 123.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4690ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2cd4f2"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m167.76,67.6h-88.43c-6.62,0-12,5.38-12,12v88.25c0,6.62,5.38,12,12,12s12-5.38,12-12v-76.25h76.43c6.62,0,12-5.38,12-12s-5.38-12-12-12Z",
    style: {
      fill: "#f7f7f7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.32,250.16c-6.62,0-12,5.38-12,12v88.25c0,6.62,5.38,12,12,12h88.43c6.62,0,12-5.38,12-12s-5.38-12-12-12h-76.43v-76.25c0-6.62-5.38-12-12-12Z",
    style: {
      fill: "#f7f7f7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m338.68,262.16v76.25h-76.43c-6.62,0-12,5.38-12,12s5.38,12,12,12h88.43c6.62,0,12-5.38,12-12v-88.25c0-6.62-5.38-12-12-12s-12,5.38-12,12Z",
    style: {
      fill: "#f7f7f7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m350.68,67.6h-88.43c-6.62,0-12,5.38-12,12s5.38,12,12,12h76.43v76.25c0,6.62,5.38,12,12,12s12-5.38,12-12v-88.25c0-6.62-5.38-12-12-12Z",
    style: {
      fill: "url(#fullscreen_svg__ds)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreen);
export default __webpack_public_path__ + "static/media/fullscreen.afab6904fcd235c2da366b50d28d7660.svg";
export { ForwardRef as ReactComponent };